import PersonalInfoSectionV2 from '../../components/sections/PersonalInfoSectionV2';
import HealthConcernsSectionV2 from '../../components/sections/HealthConcernsSectionV2';
import PastHealthMedicalHistorySectionV2 from '../../components/sections/PastHealthMedicalHistorySectionV2';
import DietaryProfileSectionV2 from '../../components/sections/DietaryProfileSectionV2';
import MedicationProfileSectionV2 from '../../components/sections/MedicationProfileSectionV2';
import SymptomBurdenSectionV2 from '../../components/sections/SymptomBurdenSectionV2';
import ClientStatementSectionV2 from '../../components/sections/ClientStatementSectionV2';
import LifestyleProfileSectionV2 from '../../components/sections/LifestyleProfileSectionV2';
import SleepProfileSectionV2 from '../../components/sections/SleepProfileSectionV2';
import DentalProfileSectionV2 from '../../components/sections/DentalProfileSectionV2';
import ToxinScreenSectionV2 from '../../components/sections/ToxinScreenSectionV2';
import PhysicalActivitySectionV2 from '../../components/sections/PhysicalActivitySectionV2';
import PsychosocialProfileSectionV2 from '../../components/sections/PsychosocialProfileSectionV2';
import OtherConditionsSectionV2 from '../../components/sections/OtherConditionsSectionV2';

export const formSections = [
  {
    id: 'personalInfo',
    component: PersonalInfoSectionV2,
    dataKey: 'personalInfo',
    practitionerDataKey: 'practitionerQuestions',
  },
  {
    id: 'healthConcerns',
    component: HealthConcernsSectionV2,
    dataKey: 'healthConcerns',
  },
  {
    id: 'pastHealthMedicalHistory',
    component: PastHealthMedicalHistorySectionV2,
    preExistingDataKey: 'preExistingConditions',
    familyHistoryDataKey: 'familyMedicalHistory',
  },
  {
    id: 'lifestyleProfile',
    component: LifestyleProfileSectionV2,
    dataKey: 'lifestyleProfile',
  },
  {
    id: 'sleepProfile',
    component: SleepProfileSectionV2,
    dataKey: 'sleepProfile',
  },
  {
    id: 'dentalProfile',
    component: DentalProfileSectionV2,
    dataKey: 'dentalProfile',
  },
  {
    id: 'toxinScreen',
    component: ToxinScreenSectionV2,
    dataKey: 'toxinScreen',
  },
  {
    id: 'physicalActivity',
    component: PhysicalActivitySectionV2,
    dataKey: 'physicalActivity',
  },
  {
    id: 'psychosocialProfile',
    component: PsychosocialProfileSectionV2,
    dataKey: 'psychosocialProfile',
  },
  {
    id: 'dietaryProfile',
    component: DietaryProfileSectionV2,
    dataKey: 'dietaryProfile',
  },
  {
    id: 'supplementsMedications',
    component: MedicationProfileSectionV2,
    dataKey: 'supplementsMedications',
  },
  {
    id: 'symptomAssessment',
    component: SymptomBurdenSectionV2,
    dataKey: 'symptomAssessment',
    genderKey: 'personalInfo.gender',
  },
  {
    id: 'healthAndMedicalConditions',
    component: OtherConditionsSectionV2,
    dataKey: 'healthAndMedicalConditions',
  },
  {
    id: 'clientStatement',
    component: ClientStatementSectionV2,
    dataKey: 'clientStatement',
    clientNameKey: 'personalInfo.fullName',
  },
];
